// Queries
import preOrder from "./PreOrderQuery.gql";

// Mutations
import movePreOrder from "./MovePreOrderUnitMutation.gql";

export const Query = {
    preOrder,
};
export const Mutation = {
    movePreOrder,
};
